/* eslint-disable boundaries/element-types */
/* eslint-disable import/order */
/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, import/no-internal-modules */
import he from 'he';
import { Card } from '@/entities/card';
import React, { forwardRef, useMemo, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import Slider from 'react-slick';

import { parseMusicians } from '@shared/libs';
import type { Locale } from '@shared/libs';
import { ItemInfo, MusicInfo, NoteInfo, Notes, NotesCardQueryData } from '@shared/types';
import { H2, Tab } from '@shared/ui';

import styles from './other-arrangements.module.css';

interface OtherArrangementsProps {
  musicians: MusicInfo[];
  title: string;
  ids: number[];
  locale: Locale;
  otherArrangement: Notes[];
  data: NotesCardQueryData['data'];
}

const OtherArrangements = forwardRef<HTMLDivElement | null, OtherArrangementsProps>(
  ({ musicians, title, locale, otherArrangement, data }, ref) => {
    const isTabletOrMobile = useMediaQuery({ maxWidth: 768 });
    const isMobile = useMediaQuery({ maxWidth: 480 });
    const [instrumentFilter, setInstrumentFilter] = useState<string | undefined>();

    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      // eslint-disable-next-line no-nested-ternary
      slidesToShow: isMobile ? 1.5 : isTabletOrMobile ? 2.5 : 4,
      slidesToScroll: 1,
      autoplay: false,
      vertical: false,
      swipeToSlide: true,
      swipe: true,
    };

    const allInstruments = useMemo(() => {

      return (
        otherArrangement
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          .map((item: NoteInfo) => item.instruments)
          .filter((item) => Boolean(item))
          .flat()
      );
    }, [otherArrangement]);

    const uniqInstruments = useMemo(() => {
      return allInstruments ? [...new Set(allInstruments.map((inst: ItemInfo) => inst.title))] : [];
    }, [allInstruments]);

    const filterTabs = useMemo(() => {
      const result: Partial<{ count: number } & ItemInfo>[] = [];

      allInstruments?.forEach((item: ItemInfo) => {
        const found = result.find((r) => r.title === item.title && r.code === item.code);
        if (found && found.count !== undefined) {
          found.count += 1;
        } else {
          result.push({ ...item, count: 1 });
        }
      });

      return result;
    }, [allInstruments]);

    const initialFilterData = useMemo(
      () =>
        uniqInstruments.length
          ? otherArrangement.filter(({ instruments }) => Boolean(instruments))
          : otherArrangement,
      [otherArrangement, uniqInstruments],
    );

    const filterData = useMemo(() => {
      return instrumentFilter
        ? initialFilterData.filter(({ instruments }) =>
            instruments?.some(({ code }) => code === instrumentFilter),
          )
        : initialFilterData;
    }, [initialFilterData, instrumentFilter]);

    if (otherArrangement.length === 0) return null;

    return (
      <div className={styles.container} ref={ref}>
        <H2 className={styles.h2}>{data.NOTE_OTHER_ARRANGEMENT_BACK}</H2>
        <div className={styles.fileName}>{`${parseMusicians(musicians)} - ${he.decode(
          title,
        )}`}</div>
        {allInstruments?.length > 1 && uniqInstruments.length > 1 && (
          <div className={styles.tabsContainerWrap}>
            <div className={styles.tabsContainer}>
              <Tab
                filled={instrumentFilter === undefined}
                onClick={() => setInstrumentFilter(undefined)}
              >
                <Tab.Title>{locale.ALL}</Tab.Title>
                <Tab.Amount>{allInstruments.length}</Tab.Amount>
              </Tab>
              {filterTabs.map((tab) => (
                <Tab
                  key={tab.code}
                  filled={instrumentFilter === tab.code}
                  onClick={() => setInstrumentFilter(tab.code)}
                >
                  <Tab.Title>{tab.title}</Tab.Title>
                  <Tab.Amount>{tab.count}</Tab.Amount>
                </Tab>
              ))}
            </div>
          </div>
        )}
        <div className={styles.cardsSlider}>
          <div className={styles.sliderWrap}>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            {filterData.map((item: NoteInfo) => (
              <Card.GridNote
                className={styles.card}
                key={item.id}
                title={item.title}
                rating={item.rating}
                img={item.img}
                musicians={item.musicians}
                views={item.views}
                likes={item.likes}
                vote_count={item.vote_count}
                arrangement={item.arrangement}
                url={item.url}
                id={item.id}
                complexity={item.complexity}
              />
            ))}
          </div>
          <div className={styles.desktopSlider}>
            <Slider {...settings}>
              {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
              {/* @ts-ignore */}
              {filterData.map((item: NoteInfo) => (
                <Card.GridNote
                  className={styles.card}
                  key={item.id}
                  title={item.title}
                  rating={item.rating}
                  img={item.img}
                  musicians={item.musicians}
                  views={item.views}
                  likes={item.likes}
                  vote_count={item.vote_count}
                  arrangement={item.arrangement}
                  url={item.url}
                  id={item.id}
                  complexity={item.complexity}
                />
              ))}
            </Slider>
          </div>
        </div>
      </div>
    );
  },
);

OtherArrangements.displayName = 'otherArrangements';

export default OtherArrangements;
